<template>
  <div class="bc-slide-menu" :class="{ 'bc-slide-menu--open': visible }">
    <div class="bc-slide-menu__backdrop" @click="close" />
    <div
      class="bc-slide-menu__panel"
      :class="{ 'bc-slide-menu__panel--open': visible }"
    >
      <div class="bc-slide-menu__bg" :style="bgStyle" />
      <div class="bc-slide-menu__overlay" />
      <div class="bc-slide-menu__content">
        <button
          type="button"
          class="bc-slide-menu__close"
          aria-label="close"
          @click="close"
        >
          ×
        </button>
        <nav
          class="bc-slide-menu__nav"
          :class="{ 'bc-slide-menu__nav--with-footer': $slots.footer }"
        >
          <button
            v-for="(item, index) in items"
            :key="itemKey(item, index)"
            type="button"
            class="bc-slide-menu__link"
            @click="onItem(item)"
          >
            <span>{{ linkLabel(item) }}</span>
            <BcMenuLinkIcon :name="item.icon || 'info'" />
          </button>
        </nav>
        <div v-if="$slots.footer" class="bc-slide-menu__footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BcMenuLinkIcon from './BcMenuLinkIcon.vue';

export default {
  name: 'BcSlideMenu',
  components: {
    BcMenuLinkIcon,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** 侧栏背景图完整 URL */
    bgImage: {
      type: String,
      default: '',
    },
    /**
     * 菜单项：{ labelKey?, label?, icon, path? }
     * labelMode 为 i18n 时用 labelKey + $T；plain 时用 label
     */
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    /** i18n：$T(item.labelKey)；plain：item.label */
    labelMode: {
      type: String,
      default: 'plain',
      validator(v) {
        return v === 'plain' || v === 'i18n';
      },
    },
  },
  computed: {
    bgStyle() {
      if (!this.bgImage) {
        return {};
      }
      return { backgroundImage: `url(${this.bgImage})` };
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    itemKey(item, index) {
      if (item && item.labelKey) {
        return item.labelKey;
      }
      if (item && item.label != null) {
        return String(item.label) + '-' + index;
      }
      return 'bc-slide-menu-item-' + index;
    },
    linkLabel(item) {
      if (!item) {
        return '';
      }
      if (this.labelMode === 'i18n' && item.labelKey) {
        return this.$T(item.labelKey);
      }
      return item.label != null ? item.label : '';
    },
    onItem(item) {
      this.$emit('select', item);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-slide-menu {
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.bc-slide-menu--open {
  pointer-events: auto;
  opacity: 1;
}
.bc-slide-menu__backdrop {
  position: absolute;
  inset: 0;
  z-index: 0;
  background: rgba(0, 0, 0, 0.5);
}
.bc-slide-menu__panel {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  max-width: 420px;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.35);
  z-index: 1;
}
.bc-slide-menu__panel--open {
  transform: translateX(0);
}
.bc-slide-menu__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-size: cover;
  background-position: center;
}
.bc-slide-menu__overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: rgba(88, 28, 135, 0.8);
}
.bc-slide-menu__content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 32px;
}
.bc-slide-menu__close {
  position: absolute;
  top: 28px;
  right: 28px;
  border: none;
  background: none;
  color: #fff;
  font-size: 40px;
  line-height: 1;
  cursor: pointer;
}
.bc-slide-menu__nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  margin-top: 48px;
}
.bc-slide-menu__nav--with-footer {
  justify-content: flex-start;
  margin-top: 72px;
}
.bc-slide-menu__link {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  border: none;
  background: none;
  color: #fff;
  font-size: 18px;
  text-align: right;
  cursor: pointer;
  padding: 8px 0;
  transition: color 0.2s;
}
.bc-slide-menu__link:hover {
  color: #e5e7eb;
}
.bc-slide-menu__link >>> .bc-menu-link__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.88);
}
.bc-slide-menu__link:hover >>> .bc-menu-link__icon {
  color: #fff;
}
.bc-slide-menu__footer {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// BcSlideMenu.vue?5566561b